import React from "react";
import DefaultSelect from "./DefaultSelect";
import { Autocomplete, TextField } from "@mui/material";
import { useTranslation } from "react-i18next";

const OptionSelect = ({ optionType, options, setFilter, filterValue }) => {
  const { t, i18n } = useTranslation();
  const sortedOptions = [...options].sort((a, b) => {
    const getLabelValue = (label) => {
      if (Array.isArray(label) && label.length > 0) {
        return label[0];
      } else if (typeof label === 'string') {
        return label;
      }
      return '';
    };
  
    const labelA = getLabelValue(a.label);
    const labelB = getLabelValue(b.label);


    const numA = Number(labelA);
    const numB = Number(labelB);
  
    if (isNaN(numA) && isNaN(numB)) {
      return labelA.localeCompare(labelB);
    } else if (isNaN(numA)) {
      return 1;
    } else if (isNaN(numB)) {
      return -1;
    } else {
      return numA - numB;
    }
  });
  
  

  const defaultProps = {
    options: sortedOptions,
    getOptionLabel: (option) => {
    const label = Array.isArray(option.label) ? option.label[0] : option.label;
    return t(label, { defaultValue: label || '' });
  }
  };

  if (optionType === "default") {
    return (
      <Autocomplete
      key={`opt-${i18n.resolvedLanguage}`}
      {...defaultProps}
      id="auto-complete"
      noOptionsText={t("No options")}
      autoComplete
      includeInputInList
      closeText={t("Close")}
      value={options.find(option => option.value === filterValue) || null} 
      onChange={(event, newValue) => {
        setFilter(newValue ? newValue.value : undefined);
      }}
      renderInput={(params) => (
        <TextField {...params} label="" placeholder={t("Select")} variant="outlined" size="small"/>
      )}
    />
    );
  } else if (optionType === "multiple") {
    return <DefaultSelect setFilter={setFilter} options={sortedOptions} variant="outlined" />;
  }

  return <div>OptionSelect</div>;
};

export default OptionSelect;
